import { formatCurrency, type FormatCurrencyOptions } from '../format-currency'
import { useCore } from '@/composables/core'

export const formatSubscriptionCurrency = (...args: [number, FormatCurrencyOptions?]): string => {
  const { store } = useCore()
  const subscriptionCurrencyCode: string | null = store.getters['subscription/currency']

  if (subscriptionCurrencyCode === null) {
    throw Error('Cannot get values from store. Did you fetch API data?')
  }

  if (subscriptionCurrencyCode) {
    args[1] = {
      ...args[1],
      currency: subscriptionCurrencyCode,
    }
  }
  return formatCurrency(...args)
}
